require('./bootstrap');

// import Alpine from 'alpinejs';

// window.Alpine = Alpine;

// Alpine.start();

document.addEventListener("DOMContentLoaded", function () {
    const nodelist = document.querySelectorAll(".js-btn-delete");
    const btns = Array.prototype.slice.call(nodelist, 0);
    btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
            if (confirm('削除しますか?')) {
                const form = btn.parentNode;
                form.submit();
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const nodelist = document.querySelectorAll(".js-btn-copy");
    const btns = Array.prototype.slice.call(nodelist, 0);
    btns.forEach(function (btn) {
        btn.addEventListener("click", function (e) {
            if (!confirm('コピー作成しますか?')) {
                e.preventDefault()
            }
        });
    });
});

$(function () {
    $('#js_all_check').on('change', function () {
        AllChecked();
    });
});

function AllChecked() {
    var check = document.querySelector("#js_all_check").checked;
    for (var i = 0; i < document.querySelectorAll(".delete_ids").length; i++) {
        document.querySelectorAll(".delete_ids")[i].checked = check;
    }
    if (check) {
        $("tr.tr-select").addClass("tr-selected");
    } else {
        $("tr.tr-select").removeClass("tr-selected");
    }
}

$(function () {
    $(document).on('change', '.selected_id', function () {
        if ($(this).prop("checked")) {
            $(this).attr('checked', true);
            $(this).parent().parent().addClass("tr-selected");
        } else {
            $(this).attr('checked', false);
            $(this).parent().parent().removeClass("tr-selected");
        }
    });
});

$(function () {
    $('.league_change').on('click', function () {
        const c_id = this.value;
        $.ajax({
            url: '../comic_site/csvs/ajax_league_change',
            type: 'GET',
            data: {
                cost_id: c_id,
            },
            beforeSend: function () {
                $('.loading').removeClass('loading_hide');
            }
        }).done(function (data) {
            $('.loading').addClass('loading_hide');
            $('.league_table').empty();

            $('.league_span').removeClass("bg-secondary");
            $('.league_span').removeClass("bg-dark");
            $('.league_span').addClass("bg-secondary");
            $('#league_span'+c_id).removeClass("bg-secondary");
            $('#league_span'+c_id).addClass("bg-dark");

            $('.league_table').append(data);
        }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
            $('.loading').addClass('loading_hide');
            $('.league_table').empty();

            $('.league_span').removeClass("bg-secondary");
            $('.league_span').removeClass("bg-dark");
            $('.league_span').addClass("bg-secondary");
            $('#league_span'+c_id).removeClass("bg-secondary");
            $('#league_span'+c_id).addClass("bg-dark");

            $('.league_table').append('通信失敗');
            console.log("failed...");
            console.log("XMLHttpRequest : " + XMLHttpRequest.status);
            console.log("textStatus     : " + textStatus);
            console.log("errorThrown    : " + errorThrown.message);
        });
    });
});
